if (document.getElementById("vue-reset")) {
    Vue.use(VeeValidate);
    new Vue({
        delimiters: ['[[', ']]'],
        mixins: [baseMixin, eventHubMixin, headerMixin, languageMixin, apiMixin],
        el: '#vue-reset',
        data: {
            form_fields: {
                email: {
                    label: 'email',
                    labelClasses: 'uppercase pb-10',
                    validate: 'required|email',
                    model: {}
                },
            },
            recaptchaToken: '',
        },
        created() {
            this.$validator.localize('fr');
        },
        mounted() {
            grecaptcha.ready(() => {
                this.reloadRecaptcha();
            })
        },
        methods: {
            reloadRecaptcha() {
                grecaptcha.execute("6LfYuz4qAAAAAHJkUmwQV9CB3O5-d9SoDOvVQJE-").then((token) => {
                    this.recaptchaToken = token
                })
            },
            login(event) {
                event.preventDefault();
                this.reloadRecaptcha();
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        let data = {
                            recaptcha_token: this.recaptchaToken
                        };
                        Object.keys(this.form_fields).forEach(key => {
                            data[key] = this.form_fields[key].model.value
                        })
                        this.post('auth/password-reset/', data).then((response) => {
                            window.location.href = '/connexion';
                        }).catch((error) => {
                            this.errors.add({
                                field: 'email',
                                msg: gettext('Erreur d\'email')
                            })
                            // console.log(error)
                        });
                    }
                })
            }
        }
    })
}
